/**
 * Cómo se enseña si una factura le ha llegado al cliente por correo.
 *
 * Vive suelto y sin importar nada, como el resto de `lib/`: la pantalla que
 * lo usa importa `@/App` y el router, y esto son cuatro líneas.
 *
 * Angel, 15-sep-2026: "un flag en las facturas en todos los estados para
 * saber si están enviadas por mail o no. Es importante para no enviarlas dos
 * veces o saber que ya fue enviada".
 */

const fecha = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/**
 * { enviada, titulo } para la fila: `enviada` decide el icono, `titulo` es
 * lo que se lee al pasar el ratón.
 *
 * Solo `email_enviado === true` cuenta como enviada. El campo no existe en
 * las facturas anteriores al 1-sep-2026, y ausente significa "no consta",
 * que para quien pregunta "¿la mando?" es un no.
 */
export function estadoDeEnvio(factura) {
  const f = factura || {};
  if (f.email_enviado === true) {
    const cuando = fecha(f.email_enviado_en);
    const veces = Number(f.email_envios) || 0;
    const partes = ['Enviada'];
    if (cuando) partes.push(`el ${cuando}`);
    if (f.email_enviado_a) partes.push(`a ${f.email_enviado_a}`);
    let titulo = partes.join(' ');
    if (veces > 1) titulo += ` (${veces} envíos)`;
    return { enviada: true, titulo };
  }
  if (f.email_ultimo_error) {
    const cuando = fecha(f.email_intentado_en);
    return {
      enviada: false,
      titulo: `Sin enviar. Falló${cuando ? ` el ${cuando}` : ''}: ${f.email_ultimo_error}`,
    };
  }
  return { enviada: false, titulo: 'Sin enviar por correo' };
}

export default estadoDeEnvio;
